module.exports = __webpack_public_path__ + "static/media/Artboard14.a21a54f8.png";